import React, { useEffect, useState } from 'react';
import {
  Spin,
  Card,
  Row,
  Col,
  Typography,
  Table,
  Select,
  Button,
  Grid, Space
} from 'antd';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  Legend,
} from 'recharts';
import { dashboardsService } from '../../common/services';
import { EyeOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { vehiculesServices } from '../../common/services';
import { promotionsServices } from '../../common/services';
import { transactionsService } from '../../common/services';
import { partenairesService } from '../../common/services';
import Can from '../../components/can'; // ✅ utiliser le composant d’ACL


const { Text } = Typography;
const { Option } = Select;

const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  let local = phone.replace('+225', '').trim();
  if (!local.startsWith('0')) {
    local = '' + local;
    // local = '0' + local;
  }
  return local.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
};

const columns = (navigate) => [
  {
    title: 'Nom',
    dataIndex: 'lastName',
    key: 'lastName',
  },
  {
    title: 'Prénom',
    dataIndex: 'firstName',
    key: 'firstName',
  },
  {
    title: 'Téléphone',
    dataIndex: 'phone',
    key: 'phone',
    render: (phone) => formatPhoneNumber(phone),
  },
  {
    title: 'Date inscription',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (date) => new Date(date).toLocaleDateString('fr-FR'),
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, record) => (
      <Button
        type="primary"
        icon={<EyeOutlined />}
        size="small"
        onClick={() => navigate(`/dashboard/partenaire/${record._id}`)}
      />
    ),
  },
];

const Home = () => {
  const [partenaireRecent, setPartenaireRecent] = useState(null);
  const [partenaireInscriptionParJour, setPartenaireInscriptionParJour] = useState([]);
  const [partenairesYandex, setPartenairesYandex] = useState(null);
  const [withVehicle, setWithVehicle] = useState([]);
  const [withoutVehicle, setWithoutVehicle] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [periodeGraphiquePromo, setPeriodeGraphiquePromo] = useState('jour');
  const [periodeGraphiqueVehicule, setPeriodeGraphiqueVehicule] = useState('jour');

  const [dataPromo, setDataPromo] = useState([]);
  const [dataVehicules, setDataVehicules] = useState([]);

  const [periodeGraphiqueSosCredit, setPeriodeGraphiqueSosCredit] = useState('jour');
  const [periodeGraphiqueTransferts, setPeriodeGraphiqueTransferts] = useState('jour');

  const [dataSosCredit, setDataSosCredit] = useState([]);
  const [dataTransferts, setDataTransferts] = useState([]);

  const [loadingSosCredit, setLoadingSosCredit] = useState(false);
  const [loadingTransferts, setLoadingTransferts] = useState(false);

  const [periodeGraphiquePartenaires, setPeriodeGraphiquePartenaires] = useState('jour');
  const [dataInscriptionsPartenaires, setDataInscriptionsPartenaires] = useState([]);
  const [loadingPartenaires, setLoadingPartenaires] = useState(false);

  const [periodeGraphiqueClasses, setPeriodeGraphiqueClasses] = useState('jour');
  const [dataClassesServices, setDataClassesServices] = useState([]);
  const [loadingClasses, setLoadingClasses] = useState(false);

  const [syncStats, setSyncStats] = useState({ tigoonCount: 0, yandexCount: 0 });

  const [periodeOps, setPeriodeOps] = useState('jour');
  const [opsData, setOpsData] = useState([]);
  const [loadingOps, setLoadingOps] = useState(false);

  // const { currentUser } = useContext(AuthContext);

  // hooks responsive
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.sm;            // < md
  const chartH = isMobile ? 220 : 300;     // hauteur des charts
  const selectW = isMobile ? '100%' : 140; // largeur Select dans Card.extra
  const cardSize = isMobile ? 'small' : 'default';
  const axisFont = isMobile ? 10 : 12;





  useEffect(() => {
    async function fetchData() {
      try {
        const [
          recent,
          daily,
          yandex,
          w,
          wo,
          promotionsStats,
          vehiculesStats,
          yandexVsTigoon,
        ] = await Promise.all([
          dashboardsService.getPartenairesRecent(),
          dashboardsService.getPartenaireInscriptionParJour(),
          dashboardsService.getPartenaireYandex(),
          dashboardsService.getPartenairesThisWeekWithVehicle(),
          dashboardsService.getPartenairesThisWeekWithoutVehicle(),
          promotionsServices.statsPromotionsDimanche(periodeGraphiquePromo),
          vehiculesServices.statsInscriptionsVehicules(periodeGraphiqueVehicule),
          dashboardsService.getYandexVsTigoon(),
        ]);

        setPartenaireRecent(recent);
        setPartenaireInscriptionParJour(daily);
        setPartenairesYandex(yandex?.count || 0);
        setWithVehicle(w);
        setWithoutVehicle(wo);
        setDataPromo(promotionsStats.data || []);
        setDataVehicules(vehiculesStats.data || []);
        setSyncStats({
          tigoonCount: yandexVsTigoon?.tigoonCount || 0,
          yandexCount: yandexVsTigoon?.yandexCount || 0,
        });
      } catch (error) {
        console.error("Erreur chargement dashboard :", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [periodeGraphiquePromo, periodeGraphiqueVehicule]);


  useEffect(() => {
    async function fetchSosCreditStats() {
      setLoadingSosCredit(true);
      try {
        const sosCreditStats = await transactionsService.statsSosCredit(periodeGraphiqueSosCredit);
        setDataSosCredit(sosCreditStats.data || []);
      } catch (error) {
        console.error("Erreur chargement SOS Crédit :", error);
      } finally {
        setLoadingSosCredit(false);
      }
    }

    fetchSosCreditStats();
  }, [periodeGraphiqueSosCredit]);

  useEffect(() => {
    async function fetchTransfertsStats() {
      setLoadingTransferts(true);
      try {
        const transfertsStats = await transactionsService.statsTransferts(periodeGraphiqueTransferts);
        setDataTransferts(transfertsStats.data || []);
      } catch (error) {
        console.error("Erreur chargement transferts :", error);
      } finally {
        setLoadingTransferts(false);
      }
    }

    fetchTransfertsStats();
  }, [periodeGraphiqueTransferts]);

  useEffect(() => {
    async function fetchStatsPartenaires() {
      setLoadingPartenaires(true);
      try {
        const data = await partenairesService.getStatsInscriptions(periodeGraphiquePartenaires);
        // console.log('Stats partenaires:', data); // 👈 Vérifie ici
        setDataInscriptionsPartenaires(data || []);
      } catch (error) {
        console.error("Erreur chargement statistiques partenaires :", error);
      } finally {
        setLoadingPartenaires(false);
      }
    }

    fetchStatsPartenaires();
  }, [periodeGraphiquePartenaires]);


  useEffect(() => {
    async function fetchStatsClassesServices() {
      setLoadingClasses(true);
      try {
        const data = await vehiculesServices.statsClassesServices(periodeGraphiqueClasses);
        // console.log('Stats classe de service:', res);
        setDataClassesServices(data || []);
      } catch (error) {
        console.error("Erreur chargement stats classes services :", error);
      } finally {
        setLoadingClasses(false);
      }
    }

    fetchStatsClassesServices();
  }, [periodeGraphiqueClasses]);

  useEffect(() => {
    (async () => {
      setLoadingOps(true);
      try {
        const res = await dashboardsService.getOperationsStats(periodeOps);
        // data: [{ periode, total, byType: { sos_credit, transfert, ... } }]
        setOpsData(res.data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoadingOps(false);
      }
    })();
  }, [periodeOps]);

  const formatDataByCategorie = (rawData) => {
    // Trouver la dernière date (ex : le jour le plus récent)
    const lastDate = rawData.length > 0
      ? rawData.map(item => item._id.periode).sort().reverse()[0]
      : null;

    // Filtrer les données de cette date
    const filtered = rawData.filter(item => item._id.periode === lastDate);

    // Trier par total décroissant et prendre les 8 premiers
    const top8 = filtered
      .sort((a, b) => b.total - a.total)
      .slice(0, 8)
      .map(item => ({
        categorie: item._id.categorie,
        total: item.total
      }));

    return top8;
  };

  const formattedCategorieData = formatDataByCategorie(dataClassesServices);


  if (loading || !partenaireRecent) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <Spin size="large">
          <div>Chargement des détails...</div>
        </Spin>
      </div>
    );
  }

  const renderSummary = (data, label) => {
    const total = data.reduce((sum, item) => sum + (item.count || 0), 0);
    const today = new Date().toLocaleDateString('fr-FR');
    return `${label} par le ${today} : ${total}`;
  };


  const totalYandex = syncStats.yandexCount;          // 100%
  const synced = Math.min(syncStats.tigoonCount, totalYandex);
  const remaining = Math.max(totalYandex - synced, 0);
  const percent = totalYandex > 0 ? Math.round((synced / totalYandex) * 100) : 0;

  const donutData = [
    { name: 'Synchronisés', value: synced },
    { name: 'Restants', value: remaining },
  ];

  const donutColors = ['#52c41a', '#f5222d'];

  // Helpers (au-dessus de ton return)
  const formatPeriodeTick = (v) => {
    const d = new Date(v);
    switch (periodeOps) {
      case 'jour':
        return d.toLocaleDateString('fr-FR'); // 09/08/2025
      case 'semaine':
        // v = début de semaine (grâce au $dateTrunc côté API)
        return `Sem. du ${d.toLocaleDateString('fr-FR')}`;
      case 'mois':
        return d.toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' }); // août 2025
      case 'annee':
        return d.getFullYear();
      default:
        return d.toLocaleDateString('fr-FR');
    }
  };

  const tooltipLabel = (v) => {
    const d = new Date(v);
    if (periodeOps === 'annee') return `Année ${d.getFullYear()}`;
    if (periodeOps === 'mois') return d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
    if (periodeOps === 'semaine') return `Semaine du ${d.toLocaleDateString('fr-FR')}`;
    return d.toLocaleString('fr-FR');
  };

  const numberFmt = (x) => (x ?? 0).toLocaleString('fr-FR');

  // Palette par type (reste cohérent partout)
  const COLORS = {
    sos_credit: '#13c2c2',
    transfert: '#722ed1',
    changement_numero: '#fa8c16',
    promo_dimanche: '#f5222d',
    vehicule_modifie: '#52c41a',
  };



  return (
    <div style={{ padding: 24 }}>
      {/* Statistiques principales */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={8}>
          <Card
            title="SYNCHRONISATION DE COMPTE YANDEX PAR RAPPORT À TIGOON"
            style={{ minHeight: 320 }}
          >
            <div style={{ textAlign: 'center' }}>
              <ResponsiveContainer width="100%" height={240}>
                <PieChart>
                  <Pie
                    data={donutData}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={100}
                    startAngle={90}
                    endAngle={-270}
                    paddingAngle={1}
                  >
                    {donutData.map((_, idx) => (
                      <Cell key={idx} fill={donutColors[idx]} />
                    ))}
                  </Pie>
                  <Tooltip formatter={(val) => val.toLocaleString('fr-FR')} />
                </PieChart>
              </ResponsiveContainer>

              {/* Bloc sous le diagramme */}
              <div style={{ marginTop: 8, textAlign: 'center' }}>
                <div style={{ fontWeight: 700, marginBottom: 8 }}>
                  {synced.toLocaleString('fr-FR')}/{totalYandex.toLocaleString('fr-FR')}
                </div>
                <div style={{ fontSize: 24, fontWeight: 700 }}>
                  {percent}% <span style={{ fontSize: 12, fontWeight: 600 }}>synchronisés</span>
                </div>

                <div style={{ marginTop: 12, display: 'flex', justifyContent: 'center', gap: 16 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ width: 10, height: 10, background: donutColors[0], borderRadius: 2 }} />
                    <span>Synchronisés</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ width: 10, height: 10, background: donutColors[1], borderRadius: 2 }} />
                    <span>Restants</span>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </Col>

        {/* Tableaux des partenaires semaine */}
        {/* Mettre mon tableau pour afficher la liste des chauffeurs TIGOON avec vehicule sur une ligne */}
        <Col xs={24} lg={16}>
          {/* Premier tableau : avec véhicule */}
          <Card
            title="Liste des chauffeurs TIGOON avec véhicule"
            style={{ marginBottom: 16 }}
            extra={
              <Link onClick={() => navigate('/dashboard/partenaires')} style={{ fontSize: 16 }}>
                <i className="bx bx-right-arrow-alt" style={{ cursor: 'pointer' }}></i>
              </Link>
            }
          >
            <Table
              dataSource={withVehicle}
              columns={columns(navigate)}
              rowKey="_id"
              pagination={{
                pageSize: 2,           // Nombre d'éléments par page
                hideOnSinglePage: true // Cache la pagination si moins de 5 éléments
              }}
              size="small"
              scroll={{ x: true }}
            />
          </Card>

          {/* Deuxième tableau : sans véhicule */}
          <Card title="Liste des chauffeurs TIGOON sans véhicule" extra={
            <Link onClick={() => navigate('/dashboard/partenaires')} style={{ fontSize: 16 }}>
              <i className="bx bx-right-arrow-alt" style={{ cursor: 'pointer' }}></i>
            </Link>
          }>
            <Table
              dataSource={withoutVehicle}
              columns={columns(navigate)}
              rowKey="_id"
              pagination={{
                pageSize: 2,           // Nombre d'éléments par page
                hideOnSinglePage: true // Cache la pagination si moins de 5 éléments
              }}
              size="small"
              scroll={{ x: true }}
            />
          </Card>
        </Col>
      </Row>

      {/* Graphiques pour les opérations */}
      <Can perm="promotions:stats">
        <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
          <Col xs={24} md={12} xl={8}>
            <Card
              size={cardSize}
              title={
                <Link to="#" style={{ color: 'inherit' }}>
                  Activations promotion dimanche
                </Link>
              }
              extra={
                <Space style={{ width: isMobile ? '100%' : 'auto' }}>
                  <Select
                    size={isMobile ? 'small' : 'middle'}
                    value={periodeGraphiquePromo}
                    onChange={setPeriodeGraphiquePromo}
                    style={{ width: selectW }}
                  >
                    <Option value="jour">Jour</Option>
                    <Option value="semaine">Semaine</Option>
                    <Option value="mois">Mois</Option>
                    <Option value="annee">Année</Option>
                  </Select>
                </Space>
              }
            >
              <ResponsiveContainer width="100%" height={chartH}>
                <BarChart data={dataPromo}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="_id"
                    tick={{ fontSize: axisFont }}
                    interval="preserveStartEnd"
                    tickMargin={isMobile ? 6 : 10}
                  />
                  <YAxis tick={{ fontSize: axisFont }} />
                  <Tooltip />
                  <Bar dataKey="count" fill="#fa541c" />
                </BarChart>
              </ResponsiveContainer>
            </Card>
          </Col>

          <Col xs={24} md={12} xl={16}>
            <Card
              size={cardSize}
              title={
                <Link to="#" style={{ color: 'inherit' }}>
                  Évolution des opérations
                </Link>
              }
              extra={
                <Space style={{ width: isMobile ? '100%' : 'auto' }}>
                  <Select
                    size={isMobile ? 'small' : 'middle'}
                    value={periodeOps}
                    onChange={setPeriodeOps}
                    style={{ width: selectW }}
                  >
                    <Option value="jour">Jour</Option>
                    <Option value="semaine">Semaine</Option>
                    <Option value="mois">Mois</Option>
                    <Option value="annee">Année</Option>
                  </Select>
                </Space>
              }
            >
              <ResponsiveContainer width="100%" height={chartH}>
                {loadingOps ? (
                  <div style={{ textAlign: 'center', paddingTop: isMobile ? 60 : 100 }}>
                    <Spin size={isMobile ? 'default' : 'large'} />
                  </div>
                ) : (
                  <BarChart data={opsData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="periode"
                      tickFormatter={formatPeriodeTick}
                      tick={{ fontSize: axisFont }}
                      interval="preserveStartEnd"
                      tickMargin={isMobile ? 6 : 10}
                    />
                    <YAxis tick={{ fontSize: axisFont }} />
                    <Tooltip
                      labelFormatter={tooltipLabel}
                      formatter={(value, name) => [numberFmt(value), name]}
                    />
                    <Legend
                      wrapperStyle={{ fontSize: axisFont, paddingTop: 8 }}
                      verticalAlign={isMobile ? 'bottom' : 'top'}
                      align={isMobile ? 'center' : 'right'}
                    />

                    {/* Empilage par type */}
                    <Bar dataKey="byType.sos_credit" name="SOS Crédit" stackId="ops" fill={COLORS.sos_credit} />
                    <Bar dataKey="byType.transfert" name="Transfert" stackId="ops" fill={COLORS.transfert} />
                    <Bar dataKey="byType.changement_numero" name="Chgt de numéro" stackId="ops" fill={COLORS.changement_numero} />
                    <Bar dataKey="byType.promo_dimanche" name="Promo dimanche" stackId="ops" fill={COLORS.promo_dimanche} />
                    <Bar dataKey="byType.vehicule_modifie" name="Véhicule modifié" stackId="ops" fill={COLORS.vehicule_modifie} />
                  </BarChart>
                )}
              </ResponsiveContainer>
            </Card>
          </Col>
        </Row>
      </Can>

      {/* graphique pour promotion et vehicules */}
      <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
        <Col xs={24} md={12} xl={8}>
          <Card
            size={cardSize}
            title={
              <Link to="/dashboard/partenaires" style={{ color: 'inherit' }}>
                Inscriptions partenaires
              </Link>
            }
            extra={
              <Space style={{ width: isMobile ? '100%' : 'auto' }}>
                <Select
                  size={isMobile ? 'small' : 'middle'}
                  value={periodeGraphiquePartenaires}
                  onChange={setPeriodeGraphiquePartenaires}
                  style={{ width: selectW }}
                >
                  <Option value="jour">Jour</Option>
                  <Option value="semaine">Semaine</Option>
                  <Option value="mois">Mois</Option>
                  <Option value="annee">Année</Option>
                </Select>
              </Space>
            }
          >
            <ResponsiveContainer width="100%" height={chartH}>
              {loadingPartenaires ? (
                <div style={{ textAlign: 'center', paddingTop: isMobile ? 60 : 100 }}>
                  <Spin size={isMobile ? 'default' : 'large'} />
                </div>
              ) : (
                <BarChart data={dataInscriptionsPartenaires}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="_id" tick={{ fontSize: axisFont }} interval="preserveStartEnd" />
                  <YAxis tick={{ fontSize: axisFont }} />
                  <Tooltip />
                  <Bar dataKey="total" fill="#13c2c2" />
                </BarChart>
              )}
            </ResponsiveContainer>
          </Card>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Card
            size={cardSize}
            title={
              <Link to="/dashboard/vehicules" style={{ color: 'inherit' }}>
                Inscriptions véhicules
              </Link>
            }
            extra={
              <Space style={{ width: isMobile ? '100%' : 'auto' }}>
                <Select
                  size={isMobile ? 'small' : 'middle'}
                  value={periodeGraphiqueVehicule}
                  onChange={setPeriodeGraphiqueVehicule}
                  style={{ width: selectW }}
                >
                  <Option value="jour">Jour</Option>
                  <Option value="semaine">Semaine</Option>
                  <Option value="mois">Mois</Option>
                  <Option value="annee">Année</Option>
                </Select>
              </Space>
            }
          >
            <ResponsiveContainer width="100%" height={chartH}>
              <BarChart data={dataVehicules}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="_id" tick={{ fontSize: axisFont }} interval="preserveStartEnd" />
                <YAxis tick={{ fontSize: axisFont }} />
                <Tooltip />
                <Bar dataKey="count" fill="#52c41a" />
              </BarChart>
            </ResponsiveContainer>
          </Card>
        </Col>

        <Col xs={24} md={12} xl={8}>
          <Card
            size={cardSize}
            title="Catégories de véhicules pour la dernière période"
            extra={
              <Space style={{ width: isMobile ? '100%' : 'auto' }}>
                <Select
                  size={isMobile ? 'small' : 'middle'}
                  value={periodeGraphiqueClasses}
                  onChange={setPeriodeGraphiqueClasses}
                  style={{ width: selectW }}
                >
                  <Option value="jour">Jour</Option>
                  <Option value="semaine">Semaine</Option>
                  <Option value="mois">Mois</Option>
                  <Option value="annee">Année</Option>
                </Select>
              </Space>
            }
          >
            <ResponsiveContainer width="100%" height={chartH}>
              {loadingClasses ? (
                <div style={{ textAlign: 'center', paddingTop: isMobile ? 60 : 100 }}>
                  <Spin size={isMobile ? 'default' : 'large'} />
                </div>
              ) : (
                <BarChart data={formattedCategorieData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="categorie"
                    tick={{ fontSize: axisFont, angle: isMobile ? -45 : -30, textAnchor: 'end' }}
                    interval={0}
                    tickMargin={isMobile ? 8 : 10}
                  />
                  <YAxis tick={{ fontSize: axisFont }} />
                  <Tooltip />
                  <Bar dataKey="total" fill="#1890ff" />
                </BarChart>
              )}
            </ResponsiveContainer>
          </Card>
        </Col>
      </Row>

      {/* Graphique pour sos crédit et transfert UV */}
      <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
        <Col xs={24} md={12}>
          <Card
            size={cardSize}
            title={
              <Link to="/dashboard/historique-sos-credit" style={{ color: 'inherit' }}>
                Statistiques SOS Crédit
              </Link>
            }
            extra={
              <Space style={{ width: isMobile ? '100%' : 'auto' }}>
                <Select
                  size={isMobile ? 'small' : 'middle'}
                  value={periodeGraphiqueSosCredit}
                  onChange={setPeriodeGraphiqueSosCredit}
                  style={{ width: selectW }}
                >
                  <Option value="jour">Jour</Option>
                  <Option value="semaine">Semaine</Option>
                  <Option value="mois">Mois</Option>
                  <Option value="annee">Année</Option>
                </Select>
              </Space>
            }
          >
            <ResponsiveContainer width="100%" height={chartH}>
              {loadingSosCredit ? (
                <div style={{ textAlign: 'center', paddingTop: isMobile ? 60 : 100 }}>
                  <Spin size={isMobile ? 'default' : 'large'} />
                </div>
              ) : (
                <BarChart data={dataSosCredit}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="_id" tick={{ fontSize: axisFont }} interval="preserveStartEnd" />
                  <YAxis tick={{ fontSize: axisFont }} />
                  <Tooltip />
                  <Bar dataKey="count" fill="#1890ff" />
                </BarChart>
              )}
            </ResponsiveContainer>

            <div style={{ marginTop: 16 }}>
              <Text type="secondary">
                {renderSummary(dataSosCredit, 'Total SOS Crédit')}
              </Text>
            </div>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card
            size={cardSize}
            title={
              <Link to="/dashboard/historique-transferts" style={{ color: 'inherit' }}>
                Statistiques Transferts
              </Link>
            }
            extra={
              <Space style={{ width: isMobile ? '100%' : 'auto' }}>
                <Select
                  size={isMobile ? 'small' : 'middle'}
                  value={periodeGraphiqueTransferts}
                  onChange={setPeriodeGraphiqueTransferts}
                  style={{ width: selectW }}
                >
                  <Option value="jour">Jour</Option>
                  <Option value="semaine">Semaine</Option>
                  <Option value="mois">Mois</Option>
                  <Option value="annee">Année</Option>
                </Select>
              </Space>
            }
          >
            <ResponsiveContainer width="100%" height={chartH}>
              {loadingTransferts ? (
                <div style={{ textAlign: 'center', paddingTop: isMobile ? 60 : 100 }}>
                  <Spin size={isMobile ? 'default' : 'large'} />
                </div>
              ) : (
                <BarChart data={dataTransferts}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="_id" tick={{ fontSize: axisFont }} interval="preserveStartEnd" />
                  <YAxis tick={{ fontSize: axisFont }} />
                  <Tooltip />
                  <Bar dataKey="count" fill="#722ed1" />
                </BarChart>
              )}
            </ResponsiveContainer>

            <div style={{ marginTop: 16 }}>
              <Text type="secondary">
                {renderSummary(dataTransferts, 'Total Transferts UV')}
              </Text>
            </div>
          </Card>
        </Col>
      </Row>











    </div>
  );
};

export default Home;
